<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">更改用户充值科目</span>
            </template>
            <template #left>
                <router-link to="/my">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/">
                    <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
                </router-link>
            </template>
        </van-nav-bar>


        <van-cell-group>
            <van-cell>
                提示：如果用户完成了支付过程，但系统由于网络之类的原因无法确认用户支付的结果时，使用此功能进行人工确认。
                可以用微信订单好号或商户订单号
            </van-cell>
            <van-cell>
                <van-field v-model="order_no" label="用户ID:" label-width="120px"/>
            </van-cell>
            <van-cell>
                <van-field v-model="pay_no" label="商户订单号:" label-width="120px"/>
            </van-cell>
            <van-cell>
                <van-button type="info" block @click="addManger">确认</van-button>
            </van-cell>
        </van-cell-group>





        <van-dialog v-model="loading" title="" :show-confirm-button="false">
            <br>
            <van-loading size="50px" vertical>{{loading_text}}</van-loading>
            <br>
        </van-dialog>


    </div>
</template>

<script>
    export default {
        data() {
            return {

                order_no: "",
                pay_no: "",

                loading: false,
                loading_text: "加载中",
                error: false,
                error_text: "",
            };
        },
        created() {

        },
        methods: {

            addManger() {
                this.$http.post("/wechat/organ/mangers", {
                    action:"add",
                    user_id:parseInt(this.user_id)
                }).then(res => {
                    this.user_id=""
                    console.log(res.data);
                    if (200 !== res.data.code) {
                        this.$toast.fail(res.data.msg);
                        return
                    }
                    this.onLoad();
                });
            },
        }
    }
</script>
